import script from "./returnManageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./returnManageDetail.vue?vue&type=script&setup=true&lang=js"

import "./returnManageDetail.vue?vue&type=style&index=0&id=40f33072&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f33072"]])

export default __exports__